/*! towsons-variant-picker.js — makes the option dropdowns choose a variant.
 *
 * Each dropdown owns the hidden option input the theme's own variant picker
 * reads. Picking a row writes that input and fires a change, which is exactly
 * what a native select would have done, so the theme goes on to swap the
 * price, the stock line, the images and the URL by itself. The single Style
 * dropdown (one row per variant) owns ALL the option inputs and writes them
 * together.
 *
 * A value belonging to another product (a combined listing) is a link, so
 * picking it goes there instead.
 */
(function () {
  'use strict';

  function ready(cb) {
    if (window.TowsonsListbox) return cb();
    var tries = 0;
    var t = setInterval(function () {
      if (window.TowsonsListbox) { clearInterval(t); cb(); }
      else if (++tries > 100) clearInterval(t);
    }, 50);
  }

  ready(function () {
    var Listbox = window.TowsonsListbox;

    // HORIZON (10 Oct 2026): the theme's own variant picker does the work — its price, stock, gallery and the
    // variant in the form — so ours, a block beside it (the theme's hidden by the block's style), ticks the theme's
    // inputs for the option values chosen and fires ONE change on the last: Horizon reads every chosen option on
    // any change (assets/variant-picker.js variantChanged), and two changes would be two fetches.
    function horizonPicker(root) {
      var t = window.Towsons;
      if (!t || String(t.family || '').toLowerCase() !== 'horizon') return null;
      var section = root.closest('.shopify-section') || document;
      return section.querySelector('variant-picker');
    }
    function drive(picker, ids) {
      var last = null;
      ids.forEach(function (id) {
        if (!id) return;
        var el = picker.querySelector('[data-option-value-id="' + String(id).replace(/"/g, '') + '"]');
        if (!el) return;
        if (el.tagName === 'OPTION') {
          var sel = el.closest('select');
          if (sel) { sel.value = el.value; last = sel; }
        } else if (el.type === 'radio') { el.checked = true; last = el; }
      });
      if (last) last.dispatchEvent(new Event('change', { bubbles: true }));
      return !!last;
    }
    // Horizon does not redraw this block: the hold comes off when the theme has the new variant.
    if (typeof document !== 'undefined') {
      document.addEventListener('variant:changed', function () {
        Array.prototype.forEach.call(document.querySelectorAll('[data-towsons-variant][data-busy]'), function (r) { r.removeAttribute('data-busy'); });
      });
    }

    function make(root) {
      var busyTimer = null;
      return new Listbox(root, {
        // A sold-out value can still be picked: the shopper gets a page that
        // says so, rather than a row that silently ignores the click.
        allowOut: true,
        onChoose: function (option, box) {
          var url = option.getAttribute('data-product-url');
          if (url) { window.location.href = url; return; }
          // The theme redraws this whole block; until it does, the button is
          // held so a second pick cannot race the first.
          root.setAttribute('data-busy', '');
          clearTimeout(busyTimer);
          busyTimer = setTimeout(function () { root.removeAttribute('data-busy'); }, 5000);
          // A row for the whole style carries every option's value id. Each
          // hidden option input takes its own, then ONE change is fired: the
          // theme reads all of them on any change, and two changes would be
          // two fetches, the first for a combination nobody chose.
          var ids = option.getAttribute('data-option-values');
          var hz = horizonPicker(root);
          if (hz) {
            var chosen = ids !== null ? ids.split('|') : [box.value ? box.value.value : ''];
            if (drive(hz, chosen)) return;
          }
          if (ids !== null) {
            var parts = ids.split('|');
            var inputs = Array.prototype.slice.call(root.querySelectorAll('input[data-option-position]'))
              .sort(function (a, b) { return parseInt(a.getAttribute('data-option-position'), 10) - parseInt(b.getAttribute('data-option-position'), 10); });
            inputs.forEach(function (inp, i) { if (parts[i] != null && parts[i] !== '') inp.value = parts[i]; });
            var last = inputs[inputs.length - 1];
            if (last) last.dispatchEvent(new Event('change', { bubbles: true }));
            return;
          }
          var input = box.value;
          if (!input) return;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }

    Listbox.mount('[data-towsons-variant]', '__towsonsVariant', make);

    // The same picker inside the basket's edit modal, where nothing redraws:
    // the editor is listening on the hidden input and saves the line itself.
    Listbox.mount('[data-towsons-line-variant]', '__towsonsLineVariant', function (root) {
      return new Listbox(root, {
        allowOut: true,
        onChoose: function (option, box) {
          if (box.value) box.value.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
  });
})();
